<template>
  <div class="flex justify-between items-center space-x-2 w-full py-2">
    
    <div v-if="title!=null" class="justify-center text-neutral-900 text-2xl font-semibold leading-9">{{ title }}</div>
    <button @click="previousPage" type="button"
            class="rounded-full bg-neutral-200 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 p-2">
      <component :is="iconComponent" class="w-5 h-5 text-black" />
    </button>
  </div>
</template>

<script>
import { ArrowLeftIcon, XMarkIcon } from '@heroicons/vue/24/outline'

export default { 
  name: 'NavigationButton',
  props: {
    previousPage: {
      type: Function,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      default: 'back'
    }
  },
  computed: {
    iconComponent() {
      return this.icon === 'close' ? XMarkIcon : ArrowLeftIcon;
    }
  },
  components: {
    ArrowLeftIcon, XMarkIcon
  }
};
</script>
